import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52bffcf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editor-toolbar" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "focus-element" }

import { PropType, computed } from "vue";
import { getElementName } from "../config";


export default /*#__PURE__*/_defineComponent({
  __name: 'Toolbar',
  props: {
  currentElement: {
    type: Object as PropType<HTMLElement | undefined>
  }
},
  emits: [
  "edit",
  "remove",
  "insertImage",
  "insertQuote",
  "insertCode",
  "insertInlineCode",
  "insertUnorderedList",
  "insertOrderedList"
],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const element = computed(() => {
  const tagName = props.currentElement?.tagName.toLowerCase() || "";

  const name = getElementName(tagName);
  if (name) {
    return {
      name,
      tagName
    };
  }
  return {
    name: "",
    tagName: ""
  };
});
const isBlockElement = computed(() =>
  ["p", "li"].includes(element.value.tagName)
);
const isOrderedListElement = computed(
  () => props.currentElement?.parentElement?.tagName.toLowerCase() === "ol"
);
const isUnorderedListElement = computed(
  () => props.currentElement?.parentElement?.tagName.toLowerCase() === "ul"
);
const hasProperties = computed(() =>
  ["img", "a", "pre"].includes(element.value.tagName)
);

const remove = () => {
  emit("remove");
};

const edit = () => {
  emit("edit");
};

const insertImage = () => {
  emit("insertImage");
};
const insertQuote = () => {
  emit("insertQuote");
};
const insertCode = () => {
  emit("insertCode");
};
const insertInlineCode = () => {
  emit("insertInlineCode");
};
const insertOrderedList = () => {
  emit("insertOrderedList");
};
const insertUnorderedList = () => {
  emit("insertUnorderedList");
};

return (_ctx: any,_cache: any) => {
  const _directive_disabled = _resolveDirective("disabled")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      disabled: !!element.value && !isBlockElement.value,
      onClick: insertQuote,
      class: "icon-quotes-left"
    }, null, 8, _hoisted_2),
    _createElementVNode("button", {
      type: "button",
      disabled: !!element.value && !isBlockElement.value,
      onClick: insertImage,
      class: "icon-image"
    }, null, 8, _hoisted_3),
    _createElementVNode("button", {
      type: "button",
      disabled: !!element.value && !isBlockElement.value,
      onClick: insertCode,
      class: "icon-embed2"
    }, null, 8, _hoisted_4),
    _createElementVNode("button", {
      type: "button",
      disabled: !!element.value && !isBlockElement.value,
      onClick: insertInlineCode,
      class: "icon-embed2"
    }, null, 8, _hoisted_5),
    _createElementVNode("button", {
      type: "button",
      disabled: !!element.value && !isBlockElement.value,
      onClick: insertOrderedList,
      class: _normalizeClass({ 'icon-list-numbered': true, active: isOrderedListElement.value })
    }, null, 10, _hoisted_6),
    _createElementVNode("button", {
      type: "button",
      disabled: !!element.value && !isBlockElement.value,
      onClick: insertUnorderedList,
      class: _normalizeClass({ 'icon-list': true, active: isUnorderedListElement.value })
    }, null, 10, _hoisted_7),
    _createElementVNode("button", {
      type: "button",
      disabled: !!element.value && !hasProperties.value,
      onClick: _withModifiers(edit, ["prevent","stop"]),
      class: "icon-cog"
    }, null, 8, _hoisted_8),
    _withDirectives(_createElementVNode("button", {
      type: "button",
      onClick: _withModifiers(remove, ["prevent","stop"]),
      class: "icon-cross"
    }, null, 512), [
      [_directive_disabled, !!element.value]
    ]),
    _createElementVNode("div", _hoisted_9, _toDisplayString(element.value?.name), 1)
  ]))
}
}

})